import styled from '@emotion/styled';
import MuiIconButton, {
  iconButtonClasses,
  IconButtonProps as IIconButtonProps,
} from '@mui/material/IconButton';

export { iconButtonClasses };
export type { IIconButtonProps };
export const IconButton = styled(MuiIconButton)`
  &.${iconButtonClasses.root} {
    color: unset;
  }
` as typeof MuiIconButton;
